import { Button } from '@/components/ui/button';
import { questionnaireApi } from '@/lib/api/questionnaireApi';
import {
  QuestionnaireProgress,
  QuestionnaireSectionProps,
} from '@/types/questionnaire';
import { router } from '@inertiajs/react';
import { useMutation } from '@tanstack/react-query';

interface StartProps {
  questionnaire_template: {
    id: number;
    title: string;
    description: string;
    questionnaire_sections: QuestionnaireSectionProps[];
  };
  questionnaire_progress?: QuestionnaireProgress;
}

export default function Start({
  questionnaire_template,
  questionnaire_progress,
}: StartProps) {
  const { mutate, isPending } = useMutation({
    mutationFn: () => questionnaireApi.create(),
    onSuccess: () => {
      router.visit('/questionnaire/form');
    },
  });

  const hasStarted =
    questionnaire_progress !== null && questionnaire_progress !== undefined;

  const handleResumeQuestionnaire = () => {
    router.visit('/questionnaire/form');
  };
  return (
    <div className="flex justify-center min-h-screen p-6 bg-white">
      <div className="flex flex-col w-full max-w-3xl gap-8">
        <div className="flex flex-col gap-5 ">
          <h1 className="text-2xl font-bold text-center text-gray-900">
            {questionnaire_template.title}
          </h1>
          <p className="text-sm text-gray-600 ">
            {questionnaire_template.description}
          </p>
        </div>

        <div>
          <h2 className="mb-8 text-xl font-semibold text-center text-gray-900">
            What to expect
          </h2>

          <div className="grid grid-cols-1 gap-5">
            {questionnaire_template.questionnaire_sections.map((section) => (
              <div
                key={section.id}
                className="flex items-start p-6 space-x-4 rounded-lg bg-gray-50"
              >
                <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-semibold text-white rounded-full bg-primary">
                  {section.section_order}
                </div>
                <div>
                  <h3 className="mb-2 font-semibold text-gray-900">
                    {section.section_name}
                  </h3>
                  <p className="text-sm leading-relaxed text-gray-600">
                    {section.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col items-center gap-5">
          {hasStarted ? (
            <div className="flex flex-col items-center gap-3">
              <p className="mb-2 text-sm text-gray-600">
                Progress: {questionnaire_progress.progress_percentage}% complete
              </p>
              <p className="text-xs text-gray-500">
                Currently at step {questionnaire_progress.current_step} of{' '}
                {questionnaire_template.questionnaire_sections.length}
              </p>
              <Button onClick={handleResumeQuestionnaire}>
                Resume Questionnaire
              </Button>
            </div>
          ) : (
            <Button onClick={() => mutate()}>
              {isPending ? 'Starting...' : 'Start Questionnaire'}
            </Button>
          )}

          <p className="text-sm text-gray-500">Takes about 15-20 minutes</p>
        </div>
      </div>
    </div>
  );
}
